import { useEffect } from 'react';
import { useMeta } from '../providers/MetaProvider';

interface PageMetaOptions {
  title?: string;
  description?: string;
  keywords?: string;
  imageUrl?: string;
  url?: string;
  type?: string;
  resetOnUnmount?: boolean;
}

export const usePageMeta = (options: PageMetaOptions) => {
  const { setMeta, resetMeta } = useMeta();
  const { resetOnUnmount = true, ...metaData } = options;

  useEffect(() => {
    // Set meta data when component mounts
    setMeta(metaData);

    // Cleanup function to reset meta when component unmounts
    return () => {
      if (resetOnUnmount) {
        resetMeta();
      }
    };
  }, [
    metaData.title,
    metaData.description,
    metaData.keywords,
    metaData.imageUrl,
    metaData.url,
    metaData.type,
    setMeta,
    resetMeta,
    resetOnUnmount
  ]);

  // Return function to update meta dynamically
  const updateMeta = (newMeta: Partial<PageMetaOptions>) => {
    setMeta({ ...metaData, ...newMeta });
  };

  return { updateMeta };
};